<template>
  <div class="subscription__info">
    {{ $t('changePlan') }}
    <router-link :to="route">
      {{ $t('changePlanLink') }}
    </router-link>
  </div>
</template>

<script>
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'SubscriptionInfo',
  setup() {
    return {
      route: { name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLAN } },
    };
  },
};
</script>

<style scoped lang="scss">
.subscription {
  &__info {
    width: 100%;
    max-width: 27.375rem;
    font-size: 0.8125rem;
    line-height: 1.3;
    color: #757575;
    border: 1px solid #EEEEEE;
    border-radius: 0.5rem;
    padding: 0.8125rem 1rem;
    margin-bottom: 1.75rem;
    a {
      color: #757575;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .subscription__info {
    margin-bottom: 1rem;
  }
}
</style>

<i18n lang="yml" locale="ru">
changePlan: Отказаться от подписки, а также изменить платёжный период вы можете в разделе
changePlanLink: Ваш тариф
</i18n>
<i18n lang="yml" locale="en">
changePlan: You can cancel your subscription or change the payment period
changePlanLink: here
</i18n>
